function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* global _ theme getCookie encryptParam */
window.theme = window.theme || {};
window.themeSettings = window.themeSettings || {};
window.themeSettings.exit_intent_enable = 'false';

theme.Sections = function () {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function _createInstance(y, S) {
    var T = $(y);
    var P = T.attr('data-section-id');
    var I = T.attr('data-section-type');

    if (S = S || this.constructors[I], !_.isUndefined(S)) {
      var A = _.assignIn(new S(y), {
        id: P,
        type: I,
        container: y
      });

      this.instances.push(A);
    }
  },
  _onSectionLoad: function _onSectionLoad(y) {
    var S = $('[data-section-id]', y.target)[0];
    S && this._createInstance(S);
  },
  _onSectionUnload: function _onSectionUnload(y) {
    this.instances = _.filter(this.instances, function (S) {
      var T = S.id === y.originalEvent.detail.sectionId;
      return T && _.isFunction(S.onUnload) && S.onUnload(y), !T;
    });
  },
  _onSelect: function _onSelect(y) {
    var S = _.find(this.instances, function (T) {
      return T.id === y.originalEvent.detail.sectionId;
    });

    !_.isUndefined(S) && _.isFunction(S.onSelect) && S.onSelect(y);
  },
  _onDeselect: function _onDeselect(y) {
    var S = _.find(this.instances, function (T) {
      return T.id === y.originalEvent.detail.sectionId;
    });

    !_.isUndefined(S) && _.isFunction(S.onDeselect) && S.onDeselect(y);
  },
  _onBlockSelect: function _onBlockSelect(y) {
    var S = _.find(this.instances, function (T) {
      return T.id === y.originalEvent.detail.sectionId;
    });

    !_.isUndefined(S) && _.isFunction(S.onBlockSelect) && S.onBlockSelect(y);
  },
  _onBlockDeselect: function _onBlockDeselect(y) {
    var S = _.find(this.instances, function (T) {
      return T.id === y.originalEvent.detail.sectionId;
    });

    !_.isUndefined(S) && _.isFunction(S.onBlockDeselect) && S.onBlockDeselect(y);
  },
  register: function register(y, S) {
    this.constructors[y] = S, $("[data-section-type=".concat(y, "]")).each(function (T, P) {
      this._createInstance(P, S);
    }.bind(this));
  }
});

theme.BannerSection = function () {
  function y(S) {
    var T = this.$container = $(S);
    var P = this.sectionId = T.attr('data-section-id');
    var I = T.attr('data-section-type');
    this.bannerId = $("#shopify-section-".concat(P)), this.bannerNamspace = "#rich-banners-".concat(P), this.placement_fullwidth = $(this.bannerNamspace).data('placement_fullwidth'), this.placement_background = $(this.bannerNamspace).data('placement_background'), this._init();
  }

  return y.prototype = _.assignIn({}, y.prototype, {
    _init: function _init() {
      if (this.placement_fullwidth == '1' && !window.sidebar) {
        var S = this.sectionId;
        onFullWidthOption(S);
      }

      this._initFx(), this._handleFontSize(), this._initSlider(), this._initTilt(), this.placement_background == '1' && this._initBackground();
    },
    _initBackground: function _initBackground() {
      var S = $("#shopify-section-".concat(this.sectionId));
      var T = this.$container.data('placement_background_c');
      var P = this.$container.data('placement_background_i');
      $(window).resize(function () {
        S.removeAttr('style');
        var I = S.offset();
        S.width($('body').width()), S.css('left', "-".concat(I.left, "px")).css('padding-left', I.left).css('padding-right', I.left), S.css('background-color', T).css('background-image', "url(".concat(P, ")")).css('background-size', 'cover');
      }).resize();
    },
    _initTilt: function _initTilt() {
      var S = this.$container.find('.rt-tilt-container');
      S.length <= 0 || (S.on('mousemove', function (T) {
        var _$$offset = $(this).offset(),
            P = _$$offset.left,
            I = _$$offset.top;

        var A = T.pageX - P;
        var z = T.pageY - I;
        var N = $(this).width() / 2 - A;
        var L = $(this).height() / 2 - z;
        $(this).css('transform', "perspective(500px) rotateX(".concat(L / 40, "deg) rotateY(").concat(-(N / 40), "deg) translateZ(10px)"));
        Math.sign(N) > 0 ? -Math.abs(N) : Math.abs(N);
        $(this).removeClass('rt-leave');
      }), S.on('mouseleave', function () {
        $(this).addClass('rt-leave');
      }));
    },
    _initSlider: function _initSlider() {
      this.$container.find('.rich-banner--group.is-slider').each(function (S, T) {
        var P = {
          interval: $(T).data('interval'),
          autoplay: $(T).data('autoplay'),
          itemsperslide: $(T).data('itemsperslide'),
          blockid: $(T).data('blockid'),
          variablewidth: $(T).data('variablewidth')
        };
        var I = $(T).not('.slick-initialized');
        I.slick({
          dots: !0,
          arrows: !1,
          slidesToShow: P.itemsperslide,
          slidesToScroll: 1,
          autoplay: P.autoplay,
          autoplaySpeed: P.interval,
          slide: 'div, a.rich-banner-wrapper',
          variableWidth: P.variablewidth,
          centerMode: P.variablewidth
        }), $(T).find('.next-button').first().click(function () {
          return I.slick('slickNext'), !1;
        }), $(T).find('.prev-button').first().click(function () {
          return I.slick('slickPrev'), !1;
        });
      });
    },
    _initFx: function _initFx() {
      this.$container.find('.rich-banner.has-text-fx').each(function (S, T) {
        var P = {
          used: $(T).data('fx'),
          type: $(T).data('fx-type')
        };
        !0 == P.used && (P.type == '0' ? anime.timeline({
          loop: !0
        }).add({
          targets: $(T).find('.rt-fx-dominos .letter').toArray(),
          rotateY: [-90, 0],
          duration: 1300,
          delay: function delay(I, A) {
            return 45 * A;
          }
        }).add({
          targets: $(T).find('.rt-fx-dominos').toArray(),
          opacity: 0,
          duration: 1e3,
          easing: 'easeOutExpo',
          delay: 1e3
        }) : P.type == '1' ? anime.timeline({
          loop: !0
        }).add({
          targets: $(T).find('.rt-fx-vertical-lines .letter').toArray(),
          scale: [0.3, 1],
          opacity: [0, 1],
          translateZ: 0,
          easing: 'easeOutExpo',
          duration: 600,
          delay: function delay(I, A) {
            return 70 * (A + 1);
          }
        }).add({
          targets: $(T).find('.rt-fx-vertical-lines .line').toArray(),
          scaleX: [0, 1],
          opacity: [0.5, 1],
          easing: 'easeOutExpo',
          duration: 700,
          offset: '-=875',
          delay: function delay(I, A, z) {
            return 80 * (z - A);
          }
        }).add({
          targets: $(T).find('.rt-fx-vertical-lines').toArray(),
          opacity: 0,
          duration: 1e3,
          easing: 'easeOutExpo',
          delay: 1e3
        }) : P.type == '2' ? anime.timeline({
          loop: !0
        }).add({
          targets: $(T).find('.rt-fx-fading .letter').toArray(),
          opacity: [0, 1],
          easing: 'easeInOutQuad',
          duration: 2250,
          delay: function delay(I, A) {
            return 150 * (A + 1);
          }
        }).add({
          targets: $(T).find('.rt-fx-fading').toArray(),
          opacity: 0,
          duration: 1e3,
          easing: 'easeOutExpo',
          delay: 1e3
        }) : P.type == '3' ? anime.timeline({
          loop: !0
        }).add({
          targets: $(T).find('.rt-fx-intro .letter').toArray(),
          translateX: [40, 0],
          translateZ: 0,
          opacity: [0, 1],
          easing: 'easeOutExpo',
          duration: 1200,
          delay: function delay(I, A) {
            return 500 + 30 * A;
          }
        }).add({
          targets: $(T).find('.rt-fx-intro .letter').toArray(),
          translateX: [0, -30],
          opacity: [1, 0],
          easing: 'easeInExpo',
          duration: 1100,
          delay: function delay(I, A) {
            return 100 + 30 * A;
          }
        }) : P.type == '4' ? anime.timeline({
          loop: !0
        }).add({
          targets: $(T).find('.rt-fx-surprising .word').toArray(),
          scale: [14, 1],
          opacity: [0, 1],
          easing: 'easeOutCirc',
          duration: 800,
          delay: function delay(I, A) {
            return 800 * A;
          }
        }).add({
          targets: $(T).find('.rt-fx-surprising').toArray(),
          opacity: 0,
          duration: 1e3,
          easing: 'easeOutExpo',
          delay: 1e3
        }) : anime.timeline({
          loop: !0
        }).add({
          targets: $(T).find('.rt-fx-typing .line').toArray(),
          scaleY: [0, 1],
          opacity: [0.5, 1],
          easing: 'easeOutExpo',
          duration: 700
        }).add({
          targets: $(T).find('.rt-fx-typing .line').toArray(),
          translateX: [0, $(T).find('.rt-fx-typing .letters').first().width()],
          easing: 'easeOutExpo',
          duration: 700,
          delay: 100
        }).add({
          targets: $(T).find('.rt-fx-typing .letter').toArray(),
          opacity: [0, 1],
          easing: 'easeOutExpo',
          duration: 600,
          offset: '-=775',
          delay: function delay(I, A) {
            return 34 * (A + 1);
          }
        }).add({
          targets: $(T).find('.rt-fx-typing').toArray(),
          opacity: 0,
          duration: 1e3,
          easing: 'easeOutExpo',
          delay: 1e3
        }));
      });
    },
    _handleFontSize: function _handleFontSize() {
      var S = this.$container;
      $(window).resize(function () {
        var T = parseInt($(window).width());
        S.find('.self-fontsize-adj').each(function () {
          if ($(this).css('fontSize', $(this).data('oriFontsize')), T <= 767) {
            var P = parseInt($(this).data('oriFontsize')) / 2;
            P = P < 10 ? 13 : P, $(this).css('fontSize', "".concat(P, "px"));
          }
        }), S.find('a.self-fontsize-adj').each(function () {
          $(this).css('fontSize', $(this).data('oriFontsize'));
        }), T <= 767 ? (S.find('a.self-fontsize-adj').css('fontSize', ''), S.find('a.self-fontsize-adj').css('padding', '7px 19px 5px')) : S.find('a.self-fontsize-adj').css('padding', '');
      }).resize();
    },
    onUnload: function onUnload() {
      this.$container.off(this.bannerNamspace);
    },
    onBlockSelect: function onBlockSelect(S) {
      console.log(S);
    },
    onSelect: function onSelect() {
      $("".concat(this.bannerNamspace, " .product-grid.rich-banner")).length > 0;
    }
  }), y;
}();

function onFullWidthOption(y) {
  _force_full_width(y), $(window).resize(function () {
    _force_full_width(y);
  });
}

function _force_full_width(y) {
  var S = $(".standard-body .full-width #shopify-section-".concat(y));

  if (!window.rtl) {
    if (S.length > 0) {
      S.width($('body').width()), S.css('left', '0px');
      var T = S.offset();
      S.css('left', "-".concat(T.left, "px")), S.find('.container').css('padding-left', T.left), S.find('.container').css('padding-right', T.left);
    }
  } else if (S.length > 0) {
    S.width($('body').width()), S.css('right', '0px');
    var T = S.offset();
    S.css('right', "-".concat(-1 * T.left, "px")), S.find('.container').css('padding-left', -1 * T.left), S.find('.container').css('padding-right', -1 * T.left);
  }

  var P = $(".standard-body .fixed #shopify-section-".concat(y));

  if (!window.rtl) {
    if (P.length > 0) {
      P.width($('.standard-body').width()), P.css('left', '0px');
      var T = P.offset();
      var I = $('.standard-body').offset();
      var A = T.left - I.left;
      P.css('left', "-".concat(A, "px")), P.find('.container').css('padding-left', A), P.find('.container').css('padding-right', A);
    }
  } else if (P.length > 0) {
    P.width($('.standard-body').width()), P.css('right', '0px');
    var T = P.offset();
    var I = $('.standard-body').offset();
    var A = T.left - I.left;
    P.css('right', "-".concat(-1 * A, "px")), P.find('.container').css('padding-left', -1 * A), P.find('.container').css('padding-right', -1 * A);
  }

  var z = $(".standard-body .fixed2 #shopify-section-".concat(y));

  if (z.length > 0) {
    z.width($('body').width()), z.css('left', '0px');
    var T = z.offset();
    z.css('left', "-".concat(T.left, "px")), z.find('.container').css('padding-left', T.left), z.find('.container').css('padding-right', T.left);
  }

  var N = $(".fixed-body #shopify-section-".concat(y));

  if (!window.rtl) {
    if (N.length > 0) {
      N.width($('.fixed-body .main-fixed').width()), N.css('left', '0px');
      var T = N.offset();
      var I = $('.fixed-body .main-fixed').offset();
      var A = T.left - I.left;
      N.css('left', "-".concat(A, "px")), N.find('.container').css('padding-left', A), N.find('.container').css('padding-right', A);
    }
  } else if (N.length > 0) {
    N.width($('.fixed-body .main-fixed').width()), N.css('right', '0px');
    var T = N.offset();
    var I = $('.fixed-body .main-fixed').offset();
    var A = T.left - I.left;
    N.css('right', "-".concat(-1 * A, "px")), N.find('.container').css('padding-left', -1 * A), N.find('.container').css('padding-right', -1 * A);
  }
}

function fixBannerHeight() {
  var screenWidth = window.innerWidth;

  if (screenWidth >= 768 && screenWidth <= 1366) {
    var bannerSection = $(".templateIndex .index-section .banner-content-wrapper");
    var resHeight = screenWidth * 0.353;
    $(bannerSection).css('minHeight', resHeight - 10);
    $(".templateIndex .rich-banner--group.is-slider").css('minHeight', resHeight - 10);
    $("#shopify-section-banner-product .banner-content-wrapper").css('minHeight', resHeight - 100);
  }
}

$(document).ready(function () {
  var y = new theme.Sections();
  y.register('banner', theme.BannerSection);
  fixBannerHeight(); //banner slideshow

  window.initHomeSlideshow = function () {
    var hpSlider = $('.banner-v2');

    if (hpSlider.length > 0 && hpSlider.find('.carousel-item').length > 1) {
      hpSlider.slick({
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        swipeToSlide: true,
        infinite: false,
        autoplaySpeed: 3000,
        lazyLoad: 'ondemand'
      });
    }
  };

  window.initHomeSlideshow(); // Homepage Spotlight

  window.initHomepageSpotlight = function () {
    var tabc = 4;
    $('.slider-spotlight').on('init', function () {
      $('.product-spotlight .template-product').css('visibility', 'visible');
      $('.product-spotlight .lds-wrapper').fadeOut();
      $(".radio-tabs-container#tab".concat(tabc, "C")).show();
    });
    ST = 4;
    prevArrow = '<span class=\"slick-arrow-custom slick-prev-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M10.121 1.061l-8 8 8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>';
    nextArrow = '<span class=\"slick-arrow-custom slick-next-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M1.061 1.061l8 8-8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>';
    $('.slider-spotlight').slick({
      slidesToShow: ST,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "110px",
      infinite: !0,
      easing: "linear",
      arrow: true,
      dots: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [{
        breakpoint: 1199,
        settings: {
          centerMode: !0,
          centerPadding: "120px",
          slidesToShow: 2
        }
      }, {
        breakpoint: 992,
        settings: {
          centerMode: !0,
          centerPadding: "80px",
          slidesToShow: 2
        }
      }, {
        breakpoint: 649,
        settings: {
          centerMode: !0,
          centerPadding: "80px",
          slidesToShow: 1
        }
      }, {
        breakpoint: 401,
        settings: {
          centerMode: !0,
          centerPadding: "53px",
          slidesToShow: 1
        }
      }]
    });
    $('.slider-spotlight').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: !0,
      centerPadding: "148px",
      infinite: !0,
      easing: "linear",
      arrow: true,
      dots: false,
      prevArrow: "<span class=\"slick-arrow-custom slick-prev-arrow\"><svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#global__symbols-left-arrow\"></use></svg></span>",
      nextArrow: "<span class=\"slick-arrow-custom slick-next-arrow\"><svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#global__symbols-right-arrow\"></use></svg></span>",
      responsive: [{
        breakpoint: 1199,
        settings: {
          centerMode: !0,
          centerPadding: "120px",
          slidesToShow: 2
        }
      }, {
        breakpoint: 992,
        settings: {
          centerMode: !0,
          centerPadding: "80px",
          slidesToShow: 2
        }
      }, {
        breakpoint: 649,
        settings: {
          centerMode: !0,
          centerPadding: "80px",
          slidesToShow: 1
        }
      }, {
        breakpoint: 401,
        settings: {
          centerMode: !0,
          centerPadding: "53px",
          slidesToShow: 1
        }
      }]
    });
    $('.homepage-blog-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: !0,
      infinite: !0,
      easing: "linear",
      arrow: true,
      dots: false,
      prevArrow: "<span class=\"slick-arrow-custom slick-prev-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M10.121 1.061l-8 8 8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>",
      nextArrow: "<span class=\"slick-arrow-custom slick-next-arrow\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11.182\" height=\"18.121\"><path d=\"M1.061 1.061l8 8-8 8\" fill=\"none\" stroke=\"#ff6ea9\" stroke-width=\"3\"/></svg></span>",
      responsive: [{
        breakpoint: 1199,
        settings: {
          centerMode: !0,
          slidesToShow: 2
        }
      }, {
        breakpoint: 992,
        settings: {
          centerMode: !0,
          centerPadding: "80px",
          slidesToShow: 2
        }
      }, {
        breakpoint: 649,
        settings: {
          centerMode: !0,
          centerPadding: "30px",
          slidesToShow: 1
        }
      }, {
        breakpoint: 401,
        settings: {
          centerMode: !0,
          centerPadding: "30px",
          slidesToShow: 1
        }
      }]
    });
  };

  window.initHomepageSpotlight();
  $('.cart-shipping-note span').on('click', function () {
    $('#shipping-table-popup').css('display', 'flex');
  });
  $('.shipping-table-popup-close').on('click', function () {
    $('#shipping-table-popup').css('display', 'none');
  });

  var initExitIntent = function initExitIntent() {
    var showPopup = function showPopup() {
      //document.querySelector('.exit-intent-popup').classList.add('visible');
      window.setCookie('exitIntentShown', true, 30);
    };

    var mouseEvent = function mouseEvent(e) {
      var shouldShowExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 10;

      if (shouldShowExitIntent) {
        document.removeEventListener('mouseout', mouseEvent);
        showPopup();
      }
    };

    var exit = function exit(e) {
      var clickNo = _toConsumableArray(e.target.classList).includes('exit-intent-popup') // user clicks on mask
      || e.target.className === 'exit-intent-popup-close' // user clicks on the close icon
      || e.target.className === 'close-text';

      var clickButton = _toConsumableArray(e.target.classList).includes('btn');

      if (clickNo || clickButton) {
        document.querySelector('.exit-intent-popup').classList.remove('visible');
      }
    };

    if (!window.getCookie('exitIntentShown') && document.querySelector('.exit-intent-popup') !== null) {
      document.addEventListener('mouseout', mouseEvent);
      document.querySelector('.exit-intent-popup').addEventListener('click', exit);
    }
  };

  if (window.themeSettings.exit_intent_enable == 'true') {
    initExitIntent();
  } // Shipping Zones


  function setWithExpiry(key, value) {
    var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60 * 60 * 1000;
    var now = new Date();
    var item = {
      value: value,
      expiry: now.getTime() + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  function getWithExpiry(key) {
    var itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return null;
    }

    var item = JSON.parse(itemStr);
    var now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  }

  var shippingZones = [];

  if (!getWithExpiry("shipping_zones")) {
    var zoneBrand = {
      "dev.skinnymint.com": "skinnymint_shopify_dev",
      "au.skinnymint.com": "skinnymint_shopify_au",
      "ca.skinnymint.com": "skinnymint_shopify_ca",
      "sg.skinnymint.com": "skinnymint_shopify_sg",
      "us.skinnymint.com": "skinnymint_shopify_us",
      "www.skinnymint.com": "skinnymint_shopify_us",
      "uk.skinnymint.com": "skinnymint_shopify_uk",
      "int.skinnymint.com": "skinnymint_shopify_rw"
    };
    var brand = zoneBrand[window.location.hostname];
    var signature = encryptParam("{brand:'".concat(brand, "',time:").concat(new Date().getTime(), "}"));
    $.ajax({
      url: "".concat(window.apiEndpoint, "/shopify/shipping_zones?brand=").concat(brand, "&signature=").concat(signature),
      success: function success(resp) {
        shippingZones = resp.zones;
        setWithExpiry("shipping_zones", JSON.stringify(resp.zones));
      }
    });
  } else {
    shippingZones = JSON.parse(getWithExpiry("shipping_zones"));
  }

  window.getShippingPrice = function (totalPrice) {
    var countryCode = getCookie('_shopify_country_code');
    var regionCode = getCookie('_shopify_country_region_name');
    var shipping = null;
    var zone = shippingZones.find(function (z) {
      var country = z.countries.find(function (c) {
        return c.code === countryCode;
      });

      if (country && countryCode === 'US') {
        var region = country.provinces.find(function (p) {
          return p.code === regionCode;
        });
        return typeof region !== 'undefined';
      }

      return typeof country !== 'undefined';
    });

    if (zone && zone.price_shipping_rates) {
      var rate = zone.price_shipping_rates.find(function (r) {
        var min = r.min_order_subtotal ? parseFloat(r.min_order_subtotal) * 100 : 0;
        var max = r.max_order_subtotal ? parseFloat(r.max_order_subtotal) * 100 : totalPrice;
        return totalPrice >= min && totalPrice <= max;
      });

      if (rate) {
        shipping = parseFloat(rate.price) * 100;
        return {
          shipping: shipping,
          zone: zone
        };
      }
    }

    return {
      shipping: shipping,
      zone: zone
    };
  };

  $('.mega-menu-type-2-li').hover(function () {
    hj('trigger', 'sm_mega_menu');

    if (!$('.full-width-search-container').hasClass('hide')) {
      $('.full-width-search-container').toggleClass('hide');
    }
  });
});